import { findGroup, locateRow } from "./find";
import { resolveBlockSurfaceColor } from "./presentation";
import type { Column, EmailDocument, Row } from "./types";

function hasBackgroundImage(backgroundImage: string | undefined): boolean {
  return Boolean(backgroundImage && backgroundImage.length > 0);
}

export function surfaceHasBackgroundImage(
  column: Column,
  row: Row,
  groupBackgroundImage?: string,
): boolean {
  return (
    hasBackgroundImage(column.backgroundImage) ||
    hasBackgroundImage(row.backgroundImage) ||
    hasBackgroundImage(groupBackgroundImage)
  );
}

export function resolveBlockSurfaceHasBackgroundImage(
  document: EmailDocument,
  rowId: string,
  columnId: string,
): boolean {
  const located = locateRow(document.sections, rowId);
  if (!located) {
    return false;
  }
  const column = located.row.columns.find(entry => entry.id === columnId);
  if (!column) {
    return false;
  }
  const group =
    located.location.parent === "group"
      ? findGroup(document.sections, located.location.groupId)
      : undefined;
  return surfaceHasBackgroundImage(
    column,
    located.row,
    group?.backgroundImage,
  );
}

export function resolveBlockSurfaceForLayout(
  document: EmailDocument,
  rowId: string,
  columnId: string,
): string {
  const located = locateRow(document.sections, rowId);
  if (!located) {
    return document.settings.contentBackgroundColor;
  }
  const column = located.row.columns.find(entry => entry.id === columnId);
  if (!column) {
    return document.settings.contentBackgroundColor;
  }
  const group =
    located.location.parent === "group"
      ? findGroup(document.sections, located.location.groupId)
      : undefined;
  return resolveBlockSurfaceColor(
    column.backgroundColor,
    located.row.backgroundColor,
    group?.backgroundColor,
    document.settings.contentBackgroundColor,
  );
}
